// extracted by mini-css-extract-plugin
export default {"zoomModal":"I3-z"};